import React from 'react';
import { motion } from 'framer-motion';
interface BuyButtonProps {
  text?: string;
  className?: string;
}
export function BuyButton({
  text = 'QUIERO MI RESET FINANCIERO',
  className = ''
}: BuyButtonProps) {
  return <motion.a href="https://checkout.vellixum.com" target="_blank" rel="noopener noreferrer" className={`inline-block w-full md:w-auto text-center px-8 py-4 rounded-full font-bold text-white text-lg md:text-xl shadow-[0_0_20px_rgba(245,158,11,0.4)] hover:shadow-[0_0_30px_rgba(245,158,11,0.6)] transition-all duration-300 bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-400 hover:to-amber-300 ${className}`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} animate={{
    boxShadow: ['0px 0px 10px rgba(245,158,11,0.4)', '0px 0px 25px rgba(245,158,11,0.7)', '0px 0px 10px rgba(245,158,11,0.4)']
  }} transition={{
    boxShadow: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  }} data-id="element-20">
      {text}
    </motion.a>;
}